import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { isNumber } from '@antv/util';
import { d3Ticks } from '../tick-methods/d3-ticks';
import { Base } from './base';
export var Constant = /*#__PURE__*/function (_Base) {
  _inherits(Constant, _Base);
  function Constant() {
    _classCallCheck(this, Constant);
    return _possibleConstructorReturn(this, _getPrototypeOf(Constant).apply(this, arguments));
  }
  _createClass(Constant, [{
    key: "getDefaultOptions",
    /**
     * 返回需要覆盖的默认选项
     * @returns 需要覆盖的默认选项
     */
    value: function getDefaultOptions() {
      return {
        range: [0],
        domain: [0, 1],
        unknown: undefined,
        tickCount: 5,
        tickMethod: d3Ticks
      };
    }
    /**
     * 输入和输出满足：y = b，其中 b 是一个常量，是 options.range 的第一个元素
     * @param _ 输入值
     * @returns 输出值（常量）
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  }, {
    key: "map",
    value: function map(_) {
      var _this$options$range = _slicedToArray(this.options.range, 1),
        v = _this$options$range[0];
      return v !== undefined ? v : this.options.unknown;
    }
    /**
     * 如果 x 是该比例尺的常量（x === b），返回输入值的范围（即定义域），否者返回 []
     * @param x 输出值 (常量）
     * @returns 定义域
     */
  }, {
    key: "invert",
    value: function invert(x) {
      var _this$options$range2 = _slicedToArray(this.options.range, 1),
        v = _this$options$range2[0];
      return x === v && v !== undefined ? this.options.domain : [];
    }
  }, {
    key: "getTicks",
    value: function getTicks() {
      var _this$options = this.options,
        tickMethod = _this$options.tickMethod,
        domain = _this$options.domain,
        tickCount = _this$options.tickCount;
      var _domain = _slicedToArray(domain, 2),
        a = _domain[0],
        b = _domain[1];
      if (!isNumber(a) || !isNumber(b)) return [];
      return tickMethod(a, b, tickCount);
    }
    /**
     * 克隆 Constant Scale
     * @returns 拥有相同选项且独立的 Constant Scale
     */
  }, {
    key: "clone",
    value: function clone() {
      return new Constant(this.options);
    }
  }]);
  return Constant;
}(Base);